import { render } from "./BaseArea.vue?vue&type=template&id=54c75374&scoped=true"
import script from "./BaseArea.vue?vue&type=script&lang=js"
export * from "./BaseArea.vue?vue&type=script&lang=js"

import "./BaseArea.vue?vue&type=style&index=0&id=54c75374&scoped=true&lang=css"

import exportComponent from "C:\\work\\01_product\\05_konoike\\01_src\\2024_4th\\stg\\ConcreteOperationManagement\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c75374"],['__file',"src/appViews/BaseArea/BaseArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54c75374"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54c75374', __exports__)) {
    console.log('reload')
    api.reload('54c75374', __exports__)
  }
  
  module.hot.accept("./BaseArea.vue?vue&type=template&id=54c75374&scoped=true", () => {
    console.log('re-render')
    api.rerender('54c75374', render)
  })

}


export default __exports__